(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const productCardHoverVideoSelector = '.card-gallery video.product-media__hover-video';

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

    const gallery = event.target.closest('.card-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;

    requestAnimationFrame(() => {
      if (!gallery.matches(':hover')) return;

      const activeSlide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
      const video = activeSlide?.querySelector(productCardHoverVideoSelector);
      if (video instanceof HTMLVideoElement) {
        video.play().catch(() => {});
      }
    });
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

    const gallery = event.target.closest('.card-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;

    for (const video of gallery.querySelectorAll(productCardHoverVideoSelector)) {
      if (!(video instanceof HTMLVideoElement)) continue;
      video.pause();
      video.currentTime = 0;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
